(function () {
  var productBlocks = document.querySelector('[data-product-blocks]');

  if (!productBlocks) return;

  function slugify(value) {
    return value
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function ensureUniqueId(element) {
    var titleSlug = slugify(element.textContent.trim()) || 'product';
    var baseId = 'cyk-title-' + titleSlug;
    var id = baseId;
    var suffix = 2;
    while (document.getElementById(id) && document.getElementById(id) !== element) {
      id = baseId + '-' + suffix++;
    }
    element.id = id;
    return id;
  }

  function updateLearnMoreLink(item) {
    var itemInfo = item.querySelector('.rebuy-addon__item-info');
    var description = itemInfo ? itemInfo.firstElementChild : null;
    var link = item.querySelector(
      '.rebuy-addon__item-learn-more-link, .rebuy-addon__item-learn-more a'
    );

    if (!description || !link) return;

    link.setAttribute('aria-describedby', ensureUniqueId(description));
    if (link.textContent.trim() !== 'Learn More') link.textContent = 'Learn More';
  }

  function updateLearnMoreLinks(root) {
    var element = root.nodeType === Node.ELEMENT_NODE ? root : root.parentElement;

    if (!element) return;

    var containingItem = element.closest('.rebuy-addon__item');
    if (containingItem) updateLearnMoreLink(containingItem);

    element.querySelectorAll('.rebuy-addon__item').forEach(updateLearnMoreLink);
  }

  updateLearnMoreLinks(productBlocks);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'characterData') {
        updateLearnMoreLinks(mutation.target);
        return;
      }

      mutation.addedNodes.forEach(updateLearnMoreLinks);
    });
  }).observe(productBlocks, { childList: true, subtree: true, characterData: true });
})();
